import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import Contact from '../../home/components/Contact';
import WhatsAppDiagnostic from '../../home/components/WhatsAppDiagnostic';

export default function AidesFinancieresFenetresLyon() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-green-600 via-emerald-500 to-teal-500 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-hand-coin-line text-white"></i>
              <span className="text-white text-sm font-medium">Aides 2025 Actualisées</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
              Aides Financières Fenêtres Lyon
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Guide complet des aides financières 2025 pour changer vos fenêtres à Lyon. MaPrimeRénov', CEE, Éco-PTZ et aides locales : maximisez vos économies.
            </p>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Aides Financières pour Fenêtres à Lyon : Guide 2025
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Changer vos fenêtres à Lyon peut représenter un investissement important. Heureusement, de nombreuses aides financières existent pour réduire considérablement votre facture. Ce guide détaillé vous présente toutes les aides disponibles en 2025, leurs conditions d'obtention et comment les cumuler.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              MaPrimeRénov' : L'Aide Principale
            </h3>
            
            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Montants 2025
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              MaPrimeRénov' est l'aide de l'État pour la rénovation énergétique. Les montants varient selon vos revenus :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>MaPrimeRénov' Bleu (revenus très modestes) :</strong> 100€ par fenêtre</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>MaPrimeRénov' Jaune (revenus modestes) :</strong> 80€ par fenêtre</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>MaPrimeRénov' Violet (revenus intermédiaires) :</strong> 40€ par fenêtre</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>MaPrimeRénov' Rose (revenus supérieurs) :</strong> Non éligible pour fenêtres seules</span>
              </li>
            </ul>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Conditions d'Éligibilité
            </h4>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">Logement de plus de 15 ans (2 ans pour remplacement chaudière fioul)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">Résidence principale (propriétaire occupant ou bailleur)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">Travaux réalisés par un artisan RGE (Reconnu Garant de l'Environnement)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">Fenêtres avec Uw ≤ 1.3 W/m².K et Sw ≥ 0.3</span>
              </li>
            </ul>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Plafonds de Revenus 2025 (Lyon - Île-de-France hors Paris)</h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Pour 1 personne : Bleu ≤ 23 541€, Jaune ≤ 28 657€, Violet ≤ 40 018€, Rose &gt; 40 018€
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Certificats d'Économies d'Énergie (CEE)
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Les CEE sont des primes versées par les fournisseurs d'énergie (EDF, Engie, Total, etc.) pour financer vos travaux d'économies d'énergie.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Montants Moyens
            </h4>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-price-tag-3-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Revenus modestes :</strong> 80€ à 120€ par fenêtre</span>
              </li>
              <li className="flex items-start">
                <i className="ri-price-tag-3-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Autres revenus :</strong> 50€ à 80€ par fenêtre</span>
              </li>
            </ul>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Comment en Bénéficier ?
            </h4>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">Contactez votre fournisseur d'énergie avant les travaux</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">Comparez les offres sur des plateformes comme Effy, Primesenergie.fr</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">Artisan RGE obligatoire</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">Cumulable avec MaPrimeRénov'</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Éco-Prêt à Taux Zéro (Éco-PTZ)
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              L'Éco-PTZ est un prêt sans intérêts pour financer vos travaux de rénovation énergétique.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Montants et Durée
            </h4>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-bank-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>1 action :</strong> Jusqu'à 15 000€ sur 15 ans</span>
              </li>
              <li className="flex items-start">
                <i className="ri-bank-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>2 actions :</strong> Jusqu'à 25 000€ sur 15 ans</span>
              </li>
              <li className="flex items-start">
                <i className="ri-bank-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>3 actions ou plus :</strong> Jusqu'à 50 000€ sur 20 ans</span>
              </li>
            </ul>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Conditions
            </h4>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-check-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">Logement construit depuis plus de 2 ans</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">Résidence principale</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">Pas de condition de revenus</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">Artisan RGE obligatoire</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">Cumulable avec MaPrimeRénov' et CEE</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              TVA Réduite à 5.5%
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              La TVA à taux réduit s'applique automatiquement sur vos travaux de rénovation énergétique.
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-percent-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>TVA 5.5% :</strong> Pour travaux d'amélioration énergétique (au lieu de 20%)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-percent-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Économie :</strong> Environ 14.5% sur le montant total TTC</span>
              </li>
              <li className="flex items-start">
                <i className="ri-percent-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Condition :</strong> Logement de plus de 2 ans, artisan RGE</span>
              </li>
              <li className="flex items-start">
                <i className="ri-percent-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Application :</strong> Automatique, attestation à signer</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Aides Locales à Lyon
            </h3>
            
            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Métropole de Lyon
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              La Métropole de Lyon propose des aides complémentaires pour la rénovation énergétique. Renseignez-vous auprès de l'Agence Locale de l'Énergie et du Climat (ALEC Lyon).
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Ville de Lyon
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Certains quartiers bénéficient d'aides spécifiques dans le cadre de programmes de rénovation urbaine. Contactez le service urbanisme de votre mairie d'arrondissement.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Aides pour Copropriétés
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-building-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>MaPrimeRénov' Copropriété :</strong> Jusqu'à 25% du montant des travaux (max 15 000€/logement)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-building-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Bonus :</strong> +500€/logement si sortie de passoire énergétique</span>
              </li>
              <li className="flex items-start">
                <i className="ri-building-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Condition :</strong> Gain énergétique minimum de 35%</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Cumul des Aides : Exemple Concret
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Exemple :</strong> Remplacement de 8 fenêtres à Lyon, coût total 5 000€ TTC, ménage aux revenus modestes (MaPrimeRénov' Jaune)
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-calculator-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>MaPrimeRénov' :</strong> 8 × 80€ = 640€</span>
              </li>
              <li className="flex items-start">
                <i className="ri-calculator-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>CEE :</strong> 8 × 100€ = 800€</span>
              </li>
              <li className="flex items-start">
                <i className="ri-calculator-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>TVA 5.5% au lieu de 20% :</strong> Économie de 630€</span>
              </li>
              <li className="flex items-start">
                <i className="ri-calculator-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Total aides :</strong> 2 070€</span>
              </li>
              <li className="flex items-start">
                <i className="ri-calculator-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Reste à charge :</strong> 2 930€ (au lieu de 5 000€)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-calculator-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Possibilité Éco-PTZ :</strong> Financement du reste à charge sans intérêts</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Démarches pour Obtenir les Aides
            </h3>
            
            <ol className="space-y-3 mb-6 list-decimal list-inside">
              <li className="text-gray-700"><strong>Avant les travaux :</strong> Créez votre compte sur maprimerenov.gouv.fr</li>
              <li className="text-gray-700"><strong>Devis :</strong> Demandez des devis à des artisans RGE certifiés</li>
              <li className="text-gray-700"><strong>CEE :</strong> Contactez les fournisseurs d'énergie pour comparer les offres</li>
              <li className="text-gray-700"><strong>Dépôt dossier :</strong> Soumettez votre demande MaPrimeRénov' avec devis</li>
              <li className="text-gray-700"><strong>Accord :</strong> Attendez la confirmation avant de signer le devis</li>
              <li className="text-gray-700"><strong>Travaux :</strong> Faites réaliser les travaux par l'artisan RGE</li>
              <li className="text-gray-700"><strong>Facture :</strong> Transmettez la facture pour versement des aides</li>
            </ol>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Points de Vigilance
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-alert-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Artisan RGE obligatoire :</strong> Vérifiez la certification sur annuaire-rge.fr</span>
              </li>
              <li className="flex items-start">
                <i className="ri-alert-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Ne signez rien avant accord :</strong> Attendez la confirmation MaPrimeRénov'</span>
              </li>
              <li className="flex items-start">
                <i className="ri-alert-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Performances minimales :</strong> Uw ≤ 1.3 W/m².K et Sw ≥ 0.3</span>
              </li>
              <li className="flex items-start">
                <i className="ri-alert-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Méfiez-vous des offres à 1€ :</strong> Souvent des arnaques</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Accompagnement Gratuit
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-customer-service-2-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>France Rénov' :</strong> 0 808 800 700 (service gratuit)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-customer-service-2-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>ALEC Lyon :</strong> Conseils personnalisés gratuits</span>
              </li>
              <li className="flex items-start">
                <i className="ri-customer-service-2-line text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Espace Conseil France Rénov' :</strong> Rendez-vous sur place à Lyon</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Conclusion
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Les aides financières pour changer vos fenêtres à Lyon peuvent couvrir 30% à 50% du coût total de vos travaux. Le cumul MaPrimeRénov' + CEE + TVA réduite est particulièrement avantageux. N'oubliez pas de faire appel à un artisan RGE et de déposer vos demandes avant de signer les devis. Pour un accompagnement personnalisé, contactez France Rénov' ou l'ALEC Lyon.
            </p>
          </article>
        </div>
      </section>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      {/* Contact */}
      <Contact />
      
      <Footer />
    </div>
  );
}
